import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from '../../global/config/app.config';
import { APP_CONFIG } from '../../global/config/config.token';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SearchModel } from '../../global/model/SearchModel';


@Injectable({
  providedIn: 'root'
})
export class DonorService {
  constructor(
    private httpClient: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig,
    private router: Router
  ) { }

  searchDonors(campaignId: number, search: string, searchFilters: string) : Observable<any[]>{
    const url = `${this.config.apiUrl}donor/donor-search?campaignId=${campaignId}&search=${search}&searchFilters=${searchFilters}`; 
   return this.httpClient.post<any[]>(url, {}, { withCredentials: true });
  }

  getDonorSearchColumnsAndFilters = (campaignId: number): Observable<SearchModel> => {
    const url = `${this.config.apiUrl}donor/donor-columns?campaignId=${campaignId}`;
    return this.httpClient.get<SearchModel>(url, { withCredentials: true });
  }
}